import * as React from "react";
import { Button, Alert } from "react-bootstrap";
import { Icon } from "src/components";

function PasswordChangedMessageComponent(props: { handleClose: () => void }) {
    return <div>
        <h3>Your password has been successfully saved.</h3>
        <Alert variant="warning" className="details-alert max-600 ms-0">
            <Alert.Heading><Icon className="ficon-alert-triangle" />For your security, PreVeil does not save your password.</Alert.Heading>
            <p>Save your password in a secure place such as your browser's password manager.</p>
        </Alert>
        <Button variant="outline-primary" onClick={props.handleClose}>Close</Button>
    </div>;

}

export default React.memo(PasswordChangedMessageComponent);